import React from 'react';
import { Field } from 'redux-form';
import { RadioButtonGroupInput, ReferenceInput, SelectInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import FileUploadSettings from './FileUploadSettings';
import HtmlContentSettings from './HtmlContentSettings';
import ImageUrlSettings from './ImageUrlSettings';
import ProductTemplateSettings from './ProductTemplateSettings';
import { SourceChannelsDomainDropdown } from '../StaticData/SourceChannels';

const styles = createStyles({
  fields: {
    width: '60%'
  }
});

type Props = {
  classes: any,
  index: number,
  item: string,
  record: any
};

const CreativeSettingsSource = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name={`${props.item}.source_channel`} source={`${props.item}.source_channel`} component={RadioButtonGroupInput} choices={SourceChannelsDomainDropdown} options={{ style: { display: 'inline' } }} label="Source Channel" />
    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.ad_campaign.creatives_attributes[props.index].source_channel === "template" &&
        <ProductTemplateSettings baseName={props.item} record={props.record} />
      }
    </FormDataConsumer>
    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.ad_campaign.creatives_attributes[props.index].source_channel === "url" &&
        <ImageUrlSettings baseName={props.item} />
      }
    </FormDataConsumer>
    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.ad_campaign.creatives_attributes[props.index].source_channel === "upload" &&
        <FileUploadSettings baseName={props.item} />
      }
    </FormDataConsumer>
    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.ad_campaign.creatives_attributes[props.index].source_channel === "text" &&
        <HtmlContentSettings baseName={props.item} />
      }
    </FormDataConsumer><br /><hr />

    <h4>Ad Size</h4>
    <Field name={`${props.item}.size`} source={`${props.item}.size`} component={ReferenceInput} resource="placements" reference="helpers/ad_sizes" sort={{ field: 'name', order: 'ASC' }} className={props.classes.dropdown} label="Ad Size" allowEmpty record={props.record}>
      <Field name={`${props.item}.size`} source={`${props.item}.size`} label="Ad Size" component={SelectInput} />
    </Field><br /><br />
  </div>
);

export default withStyles(styles)(CreativeSettingsSource);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/CreativeSettingsSource.tsx